export const slotRequestsHeaderElements = [
  { label: "Fecha", value: "fechaCreacion", align: "inherit" },
  { label: "Titular cuenta", value: "titular", align: "inherit" },
  { label: "Grano", value: "grano", align: "inherit" },
  { label: "Procedencia", value: "procedencia", align: "inherit" },
  { label: "A Planta", value: "cuposAPlanta", align: "inherit" },
  { label: "Directos", value: "cuposDirectos", align: "inherit" },
  { label: "Estado", value: "displayEstado", align: "inherit" },
];

export const assignedSlotsHeaders = [
  { label: "Número de cupo", value: "nroCupo" },
  { label: "Destino", value: "destino" },
  { label: "Tipo", value: "tipo" },
  { label: "Comprador", value: "comprador" },
  { label: "Fecha descarga", value: "fechaDescarga" },
  { label: "Estado", value: "estado" },
];
